import { mergeMeta } from '../util/merge-route-meta';

/* Notes:

1. Root and App routes do not refetch on SPA navigations. 
Dont rely on any meta data from these routes or it will be stale after user navigates

2. If a route requires custom SEO logic, import & export this function from the root. 
Handle the logic centrally in the SEO helpers. This is to stop spagetti SEO nightmares and regressions.

3. If a route needs to load meta page title from the DB you need to export localisation from the loader

4. The meta function runs on the client too! No server only files or functions

*/

export const inheritMeta = mergeMeta(() => {
    return [];
});
